import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import useCityNeighborhoods from 'modules/cities/hooks/use-city-neighborhoods';
import {NeighborhoodProps} from 'modules/neighborhoods/types';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import citiesKeys from 'modules/cities/util/cities-keys';
import toBrl from 'shared/util/to-brl';

const Neighborhoods: React.FC = () => {
  const {id} = useParams();
  const {data = [], isLoading} = useCityNeighborhoods(id!);
  const navigate = useNavigate();

  return (
    <Table<NeighborhoodProps>
      loading={isLoading}
      {...{data}}
      options={[
        'name',
        {
          value: 'deliveryPrice',
          column: (data) => data.deliveryPrice && toBrl(data.deliveryPrice),
        },
        {
          value: 'deliveryManFee',
          column: (data) => data.deliveryManFee && toBrl(data.deliveryManFee),
        },
        {
          value: 'id',
          column: (row) => (
            <QueryDeleteButton
              queryKey={citiesKeys.neighborhoods(id!)}
              url={`/neighborhoods/${row.id}`}
              type="update"
            />
          ),
        },
      ]}
      translatedPropsKey="NeighborhoodProps"
      onRowClick={(row) => navigate(row.id, {state: row})}
    />
  );
};

export default Neighborhoods;
